// Owner: account-settings (plan §9.3). Account › Security.
import { createFileRoute } from '@tanstack/react-router';
import { SecurityPage } from '../../../features/account/SecurityPage';

export const Route = createFileRoute('/_settings/account/security')({
  component: SecurityPage,
});
